import Vue from 'vue'
import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types'

import EmployeeCard from '@appbase/components/common/EmployeeCard/EmployeeCard.vue';

@Component({
    components: {
        EmployeeCard
    },
    computed: mapGetters({
        user: accountTypes.CURRENT
    })
})
export default class MyInfoWebpart extends Vue {
    user!: account.TCurrent;

    isCardOpen: boolean = false;

    onClickCardOpen() {
        this.isCardOpen = true;
    }

    onClickCardClose() {
        this.isCardOpen = false;
    }

    getPhotoUrl(){
        if(this.user.user.photoPath && this.user.user.photoPath != ""){
            return this.user.user.photoPath
        }else{
            return "/cm/gres/faux/images/ghost.png"
        }
    }
}
